import FileUploadResult from './file-upload-result.js';
import UploaderFile from './uploader-file.js';

interface FilesUploadedInfo {
  allFiles: Array<UploaderFile>;
  filesUploaded: Array<FileUploadResult>;
  filesNotUploaded: Array<FileUploadResult>;
}

export default FilesUploadedInfo;
